const clients = [
    'givenchy',
    'mustela',
    'daru',
    'danone',
    'eiffage',
    'fendi',
    'masterlock',
    'inserm',
    'bpi',
    'doris',
    'tommy',
    'stratpharma',
    'mapa',
    'ogf',
    'gresser',
    'ffj',
    'sandoz',
    'coca',
];

export default clients;